export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAAAtAQMAAAAUQe44AAAAA1BMVEUcms5FNOrpAAAADklEQVQoz2MYBaOAGgAAAkkAAQmr4rUAAAAASUVORK5CYII="